import { mapGetters, mapActions } from "vuex"
export default {
    computed: {
        ...mapGetters({
            isLoggedIn: 'getisLoggedIn',
            isMobile: 'getIsMobile'
        })
    },
    methods: {
        ...mapActions({
            setActiveTab: 'setActiveTab',
            setBreadcrumb: 'setBreadcrumb',
            showSnackbar: 'showSnackbar'
        }),
        getResponse(moduleName){
            const status = this.$store.getters[`${moduleName}/getStatus`]
            const msg = this.$store.getters[`${moduleName}/getMsg`]
            return { status , msg}
        },
    }
}